<template>
  <div class="contact-lookup">
    <v-img src="/images/offer/init-offer.png" class="init-image-header mt-10" />

    <v-card-text class="label-init-search pt-8 pb-0">
      {{ text }}
    </v-card-text>

    <v-card-text>
      <v-form v-model="isFormValid">
        <div class="d-flex flex-inline justify-center">
          <m-phone-field
            ref="searchContactInput"
            v-model="searchInput"
            type="tel"
            class="search-input"
            data-cy="search-field"
            dense
            hide-details="auto"
            clear-icon="z"
            outlined
            :maxlength="20"
            @keypress="stickToPhoneNumberDigits"
            @keydown.enter.prevent="searchContact"
            autofocus
            v-bind="$attrs"
            :error-invalid-phone="$t('honda.validation.phone')"
            error-required-phone=" "
            required
            :country="country" />
          <v-btn
            class="btn-primary px-10 btn-search"
            @click="searchContact"
            :loading="loading"
            :disabled="!isFormValid">
            ?
          </v-btn>
        </div>
      </v-form>

      <result-info-box v-if="error" class="mt-5" type="ERROR" :text="messageError" />
      <result-info-box v-else-if="contactNotFound" class="mt-5" type="WARNING" :text="messageNotFound" />
    </v-card-text>
  </div>
</template>

<script lang="ts">
import {Country} from '@mapit/common-utils/dist/types'
import Vue, {PropType} from 'vue'
import {mapGetters} from 'vuex'

import {DealersContactsApi} from '@/api/dealersContacts.api'
import ResultInfoBox from '@/components/general/ResultInfoBox.vue'
// @ts-ignore
import {isPhoneNumberEvent} from '@/helpers/validations'
import {Contact} from '@/types/dynamodb-types'

type BaseData = {
  searchInput: string
  contactNotFound: boolean
  error: boolean
  loading: boolean
  isFormValid: boolean
  searched: boolean
}

export default Vue.extend({
  name: 'ContactLookup',
  components: {ResultInfoBox},
  props: {
    value: {
      type: Object as () => Contact,
      required: false,
    },
    text: String,
    messageNotFound: {
      type: String,
      default: () => 'No se ha encontrado el contacto',
    },
    messageError: {
      type: String,
      default: () => 'Error',
    },
    country: {
      type: String as PropType<Country>,
      default: Country.Spain,
    },
  },
  data(): BaseData {
    return {
      searchInput: '',
      contactNotFound: false,
      error: false,
      loading: false,
      isFormValid: false,
      searched: false,
    }
  },
  computed: {
    ...mapGetters({
      group: 'getGroup',
    }),
  },
  watch: {
    searchInput: function (val) {
      this.searched = false
    },
    searched: function (newVal, val) {
      if (val && !newVal) {
        this.$emit('input', null)
        this.$emit('search', '', null)
        this.contactNotFound = false
      }
    },
  },
  methods: {
    async searchContact(): Promise<void> {
      this.error = false
      this.contactNotFound = false

      if (this.isFormValid) {
        this.loading = true
        try {
          const res = await new DealersContactsApi().getContactByPhone(this.searchInput, this.group.dealerId)
          const contact = res.data.data.length ? res.data.data[0] : null

          if (contact) {
            if (!contact.gdprConsent) contact.gdprConsent = true
            if (!(contact as any).privacyTermsAccepted) (contact as any).privacyTermsAccepted = true
            contact.phone = this.searchInput
          } else {
            this.contactNotFound = true
          }
          this.searched = true
          this.$emit('input', contact)
          this.$emit('search', this.searchInput, contact)
        } catch (e) {
          console.error('Problem finding contact', e)
          this.$emit('search', null)
          this.error = true
        } finally {
          this.loading = false
        }
      }
    },
    stickToPhoneNumberDigits: isPhoneNumberEvent,
  },
})
</script>

<style lang="scss" scoped>
.init-image-header {
  max-width: 160px;
  margin: auto;
  text-align: center;
}

.label-init-search {
  text-align: center;
  font: normal normal normal 16px/26px 'ProximaNovaRegular';
  letter-spacing: 0px;
  color: var(--v-gray-darken4);
  opacity: 1;
}

#app .btn-search,
.btn-search {
  height: 50px !important;
  font-family: 'mapitfont-v1' !important;
}
</style>
